import { useNavigate } from "react-router-dom";
import { categories } from "@/mocks/products";

const CategoriesSection = () => {
  const navigate = useNavigate();

  return (
    <section className="py-20 bg-amber-50">
      <div className="max-w-screen-xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <p className="text-amber-500 text-xs font-semibold uppercase tracking-widest mb-3">Browse by Category</p>
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900" style={{ fontFamily: "'Playfair Display', serif" }}>
            Explore Product Categories
          </h2>
          <p className="text-gray-500 mt-3 text-base max-w-xl mx-auto">
            From electronics to textiles — find verified suppliers across every industry
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
          {categories.map((cat, i) => (
            <button
              key={cat.name}
              onClick={() => navigate(`/products?category=${cat.name.toLowerCase()}`)}
              className={`group relative rounded-2xl overflow-hidden cursor-pointer transition-all duration-300 hover:-translate-y-1 text-left ${
                i % 2 === 0
                  ? "bg-gradient-to-br from-amber-500 to-amber-700 text-white"
                  : "bg-white border border-amber-100 text-gray-800"
              }`}
            >
              <div className="p-6">
                <div className={`w-12 h-12 flex items-center justify-center rounded-xl mb-4 ${
                  i % 2 === 0 ? "bg-white/20" : "bg-amber-50"
                }`}>
                  <i className={`${cat.icon} text-2xl ${i % 2 === 0 ? "text-white" : "text-amber-500"}`}></i>
                </div>
                <div className={`text-xs font-semibold mb-1 ${i % 2 === 0 ? "text-amber-200" : "text-amber-500"}`}>
                  {cat.count.toLocaleString()} products
                </div>
                <div className="font-bold text-base leading-tight">{cat.name}</div>
                <div className={`flex items-center gap-1 mt-3 text-xs font-medium ${
                  i % 2 === 0 ? "text-amber-200" : "text-amber-500"
                }`}>
                  View Suppliers <i className="ri-arrow-right-line"></i>
                </div>
              </div>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CategoriesSection;
